import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../repositories/auth.repository';

/**
 * Use case para verificar estado de autenticação
 * Baseado no verificar_autenticacao_usecase.dart do Flutter
 */
@Injectable({
  providedIn: 'root'
})
export class VerificarAutenticacaoUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Verifica se o usuário está autenticado
   * @returns Observable<boolean> - true se autenticado
   */
  execute(): Observable<boolean> {
    return this.authRepository.isAuthenticated();
  }
}
